// client/src/sanityWrite.js

//Sanity clients to manage the message submission by the viewers/users.
import { createClient } from '@sanity/client';

const writeClient = createClient({
  projectId: '96l46hgm',
  dataset: 'production',
  apiVersion: '2023-09-11',
  useCdn: false, // ❌ must bypass CDN
  token: process.env.REACT_APP_SANITY_WRITE_TOKEN, // ✅ secure token
});

export default writeClient;
